import React, { Component } from 'react';

import { getFormValues } from '../helpers/Fields';

import { domainUrl } from '../config/Config';

import {
    reactLoader,
    getTokenData,
    message,
    scrollToTop,
    contentResizeLoad,
    showSmallLeftMenu
} from '../helpers/Common';

import { runValidation } from '../helpers/Validation';

import Inputgenerator from '../components/Inputgenerator';

export default class Cfeedbackform extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formName: "",
            altText: "",
            icon: "",
            questions: [],
            dynamicFormData: {}
        };
    }
    getFeedbackForm(data) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "get-feedback-form", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 0) {
                message(responseJson.message, responseJson.errors, "error");
            } else {
                this.setState({
                    formName: responseJson.data.formName,
                    altText: responseJson.data.altText,
                    icon: responseJson.data.icon,
                    questions: responseJson.data.questions,
                    dynamicFormData: responseJson.data
                });
                setTimeout(() => {
                    contentResizeLoad();
                    showSmallLeftMenu();
                    contentResizeLoad();
                    reactLoader("hide");
                }, 200);
            }
        });
    }
    componentDidMount() {
        const { data } = this.props;        
        this.getFeedbackForm(data);
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.getFeedbackForm(data);
    }
    submitFeedbackForm() {
        if (runValidation()) {
            let dynamicFormData = getFormValues(this.state.dynamicFormData);
            const {
                data
            } = this.props;
            reactLoader("show");
            fetch(domainUrl + "post-feedback-form", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    data: data,
                    form_data: dynamicFormData
                })
            }).then((response) => response.json()).then((responseJson) => {
                reactLoader("hide");
                if (responseJson.status == 0) {
                    message(responseJson.message, responseJson.errors, "error");
                } else {
                    scrollToTop();
                    this.props.switchback(data);
                }
            });
        }
    }
    goToThanksPage() {
        const {
            data
        } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }
    render() {
        const feedbackQuestionsHtml = this.state.questions.map((val, key) => {
            return <div key={`feedback_question_${key}`} className="fdbk-questn">
            {val.questionLabel}
            <span className="greenbg">{key+1}</span>
            <span className="codeno"></span>
            <ul>
                <li><Inputgenerator qDetails={val} /></li>
            </ul>
        </div>
        });
        return (<div className="main-inner">
          <div className="border-box">
              <div className="title-box tit-new">
                  <div className="fb_complete_button" title={this.state.altText}>{this.state.icon}</div>
                  <h6>{this.state.formName}</h6><span className="bluetxt"></span>
              </div>
              <section id="semana-scroll-inner" className="scroll">
                  <section className="viewport">
                      <section className="overview">
                          <div className="inner-content">
                              {feedbackQuestionsHtml}
                              <div className="clear"></div>
                              <div style={{textAlign: "right"}}>
                                  <input type="button" value="Continue" title="Continue" onClick={()=>this.submitFeedbackForm()} />
                              </div>
                          </div>
                      </section>
                  </section>
              </section>
          </div>
      </div>);
    }
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Cfeedbackform.js